import React from "react";

interface ResultHeadingProps {
  groupName: string;
  city?: any;
}

export const ResultHeading = ({ groupName, city }: ResultHeadingProps) => {
  switch (groupName) {
    case "popular":
      return (
        <div className="font-openSans px-[28px] pt-[19px] pb-[18px]">
          <div className="text-web-body-md text-brand-textLightGrey font-semibold uppercase">
            Popular Searches
          </div>
        </div>
      );
      break;
    case "locality":
      return (
        <div className="font-openSans px-[28px] pt-[19px]">
          <div className="text-web-body-md text-brand-textLightGrey font-semibold uppercase">
            Locality
          </div>
        </div>
      );
      break;
    case "not_found":
      return (
        <div className="font-openSans px-5 pt-3 pb-[14px]">
          <div className="text-web-body-lg text-brand-textRed">
            We could not find this in{" "}
            <span className="capitalize">{city.label}</span>
          </div>
          <div className="text-web-body-sm text-gray-600">
            Here are some other results
          </div>
        </div>
      );
      break;
    case "other_results_in_same_asset_type":
      return (
        <div className="font-openSans px-5 pt-3">
          <div className="text-web-body-md text-brand-borderGrey uppercase">
            Other search results
          </div>
        </div>
      );
      break;

    default:
      return <div></div>;
      break;
  }
};
